<!--  -->
<template>
  <div class="classification">
    <div class="header">
      <span class="font" style="display: flex; align-items: center"
        >{{ type == "add" ? "新增" : "编辑" }}资讯分类
      </span>
    </div>

    <div class="center" style="position: relative">
      <el-form
        ref="formTool"
        :rules="rules"
        :model="formTool"
        label-position="right"
        label-width="80px"
      >
        <el-form-item prop="classifyName" label="分类名称">
          <el-input
            v-model="formTool.classifyName"
            style="width: 400px"
            maxlength="10"
            show-word-limit
            placeholder="请输入分类名称"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item label="上级分类">
          <el-select
            v-model="sortOne"
            @change="changeSortOne"
            :clearable="
              (formTool.nodeInfo && formTool.nodeInfo.length == 1) || type == 'add'
            "
            style="width: 190px"
            size="small"
            @clear="clearSortOne"
            :disabled="
              type == 'edit' && formTool.nodeInfo && formTool.nodeInfo.length == 1
            "
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionsOne"
              :key="item.id"
              :label="item.classifyName"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="sortTwo"
            style="margin-left: 16px; width: 190px"
            @change="changeSortTwo"
            :clearable="
              (formTool.nodeInfo && formTool.nodeInfo.length == 2) || type == 'add'
            "
            @clear="clearSortTwo"
            size="small"
            :disabled="
              type == 'edit' && formTool.nodeInfo && formTool.nodeInfo.length != 3
            "
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionsTwo"
              :key="item.id"
              :label="item.classifyName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="operationAuthority" label="是否启用">
          <el-checkbox-group v-model="formTool.operationAuthority">
            <el-checkbox label="商户端" :disabled="salesFlag"></el-checkbox>
            <el-checkbox label="客户端" :disabled="clientFlag"></el-checkbox>
            <el-checkbox label="业务端" :disabled="businessFlag"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item prop="newSort" label="排序">
          <el-input-number
            class="sort-input-number"
            v-model="formTool.newSort"
            placeholder="请输入排序"
            controls-position="right"
            size="small"
            :min="1"
            :max="9999"
            style="width: 400px"
          ></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="addClassify('add')"
            >确认</el-button
          >
          <el-button size="small" style="margin-left: 16px" @click="cancel()"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  queryInformationClassifyByParentId,
  addClassify,
  editClassify,
  queryInformationClassifyByParentIdByWCB
} from "@/api/message/InformationClassification";

export default {
  name: "WareProduct",
  components: {},
  data() {
    return {
      type: "",
      sortOne: "",
      sortTwo: "",
      formTool: {
        classifyName: "",
        operationAuthority: [],
        newSort: "",
      },
      optionsOne: [],
      optionsTwo: [],
      rules: {
        classifyName: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
        newSort: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
      salesFlag: false, // 商户端是否禁用
      clientFlag: false, // 客户端是否禁用
      businessFlag: false, // 业务端是否禁用
    };
  },
  computed: {},
  watch: {},
  async created() {
    this.type = this.$route.query.type;
    if (this.$route.query.type == "edit") {
      this.formTool.classifyName = this.$route.query.classifyName;
      this.formTool.newSort = this.$route.query.newSort;
      this.formTool.operationAuthority = this.$route.query.operationAuthority
        ? this.$route.query.operationAuthority.split(",")
        : [];
      this.formTool.nodeInfo = this.$route.query.nodeInfo
        ? this.$route.query.nodeInfo.split(",")
        : [];
    }
    if (this.$route.query.type == "clickrow") {
      this.formTool.nodeInfo = this.$route.query.nodeInfo
        ? this.$route.query.nodeInfo.split(",")
        : [];
    }
    await this.queryInformationClassifyByParentId(0);
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: {
    // 下拉选择改变
    changeSortOne(value) {
      if (value) {
        const currentList = this.optionsOne.filter((item) => item.id == value);
        if (currentList.length) {
          this.formTool.operationAuthority = currentList[0].operationAuthority.split(",");
          if (currentList[0].operationAuthority) {
            const str = currentList[0].operationAuthority;
            this.salesFlag = !str.includes("商户端");
            this.clientFlag = !str.includes("客户端");
            this.businessFlag = !str.includes("业务端");
          }else{
            this.salesFlag = false; // 商户端是否禁用
            this.clientFlag = false; // 客户端是否禁用
            this.businessFlag = false; // 业务端是否禁用
          }
        }
        this.queryInformationClassifyByParentId(value);
      }
      this.sortTwo = "";
    },
    changeSortTwo(value) {
      if (value) {
        const currentList = this.optionsTwo.filter((item) => item.id == value);
        if (currentList.length) {
          this.formTool.operationAuthority = currentList[0].operationAuthority.split(",");
          if (currentList[0].operationAuthority) {
            const str = currentList[0].operationAuthority;
            this.salesFlag = !str.includes("商户端");
            this.clientFlag = !str.includes("客户端");
            this.businessFlag = !str.includes("业务端");
          }else{
            this.salesFlag = false; // 商户端是否禁用
            this.clientFlag = false; // 客户端是否禁用
            this.businessFlag = false; // 业务端是否禁用
          }
        }
      }
    },
    clearSortOne() {
      this.salesFlag = false; // 商户端是否禁用
      this.clientFlag = false; // 客户端是否禁用
      this.businessFlag = false; // 业务端是否禁用
      this.formTool.operationAuthority = [];
    },
    clearSortTwo() {
      if (this.sortOne) {
        const currentList = this.optionsOne.filter((item) => item.id == this.sortOne);
        this.formTool.operationAuthority = currentList[0].operationAuthority.split(",");
        const str = currentList[0].operationAuthority;
        this.salesFlag = !str.includes("商户端");
        this.clientFlag = !str.includes("客户端");
        this.businessFlag = !str.includes("业务端");
      } else {
        this.formTool.operationAuthority = [];
      }
    },
    // 编辑
    editHandle(params) {
      editClassify(params).then((res) => {
        if (res) {
          this.$message.success("修改成功");
          this.cancel();
        }
      });
    },
    // 切换分页
    getList() {
      this.getWarebase();
    },
    // 查询出售中的商品
    getWarebase(current) {
      if (current) {
        // 搜索条件改变从第一页开始查询
        this.page.current = current;
      }
      const params = {
        current: this.page.current,
        size: this.page.size,
      };
      getWarebase(params).then((res) => {
        if (res.code == 0 && res.data) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
    // 添加资讯分类
    addClassify() {
      this.$refs["formTool"].validate((valid) => {
        if (valid) {
          let params = {
            classifyName: this.formTool.classifyName,
            parentId: this.sortTwo ? this.sortTwo : this.sortOne ? this.sortOne : "0",
            sort: this.formTool.newSort,
            operationAuthority:
              this.formTool.operationAuthority.length > 0
                ? this.formTool.operationAuthority.join()
                : "",
          };
          if (this.type == "add" || this.type == "clickrow") {
            addClassify(params).then((res) => {
              if (res) {
                this.$message.success("新增成功");
                this.cancel();
              }
            });
          } else {
            if (!this.sortTwo && this.formTool.nodeInfo.length == 3) {
              this.$message.warning("请选择上级分类");
              return;
            }
            params.id = this.$route.query.id;
            this.editHandle(params);
          }
        }
      });
    },
    // 查询三级分类
    async queryInformationClassifyByParentId(id) {
      queryInformationClassifyByParentIdByWCB(id).then((res) => {
        if (id == 0) {
          this.optionsOne = res;
          if (this.formTool.nodeInfo && this.formTool.nodeInfo.length == 1) {
            this.sortOne = "";
            this.sortTwo = "";
          } else if (this.formTool.nodeInfo && this.formTool.nodeInfo.length == 2) {
            this.sortOne = this.formTool.nodeInfo[1];
            this.sortTwo = "";
            this.queryInformationClassifyByParentId(this.sortOne);
            if (this.formTool.nodeInfo.length == 2) {
              const currentOne = res.filter(
                (item) => this.formTool.nodeInfo[1] == item.id
              );
              if (currentOne && currentOne.length && currentOne[0].operationAuthority) {
                const str = currentOne[0].operationAuthority;
                this.salesFlag = !str.includes("商户端");
                this.clientFlag = !str.includes("客户端");
                this.businessFlag = !str.includes("业务端");
              }
            }
          } else if (this.formTool.nodeInfo && this.formTool.nodeInfo.length == 3) {
            this.sortOne = this.formTool.nodeInfo[2];
            this.sortTwo = this.formTool.nodeInfo[1];
            this.queryInformationClassifyByParentId(this.sortOne);
          }
        } else {
          this.optionsTwo = res;

          if (this.formTool.nodeInfo && this.formTool.nodeInfo.length == 3) {
            const currentOne = res.filter((item) => this.formTool.nodeInfo[1] == item.id);
            if (currentOne && currentOne.length && currentOne[0].operationAuthority) {
              const str = currentOne[0].operationAuthority;
              this.salesFlag = !str.includes("商户端");
              this.clientFlag = !str.includes("客户端");
              this.businessFlag = !str.includes("业务端");
            }
          }
        }
      });
    },
    // 取消
    cancel() {
      this.$router.back(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.classification {
  padding: 0px;
}
.header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px 0px 24px !important;
  border-bottom: 1px solid #f5f5f5;
  .font {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    text-align: left;
    color: #262626;
  }
}
.center {
  margin-top: 16px;
  padding: 0 24px 0 24px;
  height: calc(100% - 131px);
  ::v-deep .imageP {
    width: calc(100% - 110px);
    p {
      margin: 0 0 0 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .shangjia {
    position: absolute;
    z-index: 2;
    bottom: -45px;
  }
}
.sort-input-number {
  ::v-deep.el-input-number .el-input__inner {
    text-align: left;
  }
}
</style>
